import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Leaderboards from './pages/Leaderboards';
import Benefits from './pages/Benefits';
import Store from './pages/Store';
import Cases from './pages/Cases';
import Raffles from './pages/Raffles';
import TTS from './pages/TTS';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/leaderboards" element={<Leaderboards />} />
        <Route path="/benefits" element={<Benefits />} />
        <Route path="/raffles" element={<Raffles />} />
        <Route path="/store" element={<Store />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/tts" element={<TTS />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Route>
    </Routes>
  );
}
